export const getCalendarViewOptions = (t: any) => [
  {
    title: t('general.monthly'),
    value: 'month',
    class: 'calendar-icon ic_view_month',
  },
  {
    title: t('general.weekly'),
    value: 'week',
    class: 'calendar-icon ic_view_week',
  },
  {
    title: t('general.daily'),
    value: 'day',
    class: 'calendar-icon ic_view_day',
  },
];
